import { render, staticRenderFns } from "./updateVersion.vue?vue&type=template&id=fc64250e&"
import script from "./updateVersion.vue?vue&type=script&lang=js&"
export * from "./updateVersion.vue?vue&type=script&lang=js&"
import style0 from "./updateVersion.vue?vue&type=style&index=0&id=fc64250e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports